import $ from 'jquery';
import React from 'react';
import Router from 'react-router/lib/Router';
import Route from 'react-router/lib/Route';
import applyRouterMiddleware from 'react-router/lib/applyRouterMiddleware';
import { useScroll } from 'react-router-scroll';
import barberRoutes from './app/barber/routes';
import shopRoutes from './app/shopRoutes';
import publicRoutes from './app/publicRoutes';
import adminRoutes from './app/admin/routes';
import customerRoutes from './app/customer/routes';
import brandRoutes from './app/brand/routes';
import authRedirectRoutes from './app/authRedirectRoutes';
import { containerApp } from './main';
import {
  getActiveBrandId,
  getShop,
} from './app/auth/selectors';
import { RouterBridge } from './modules/infra/routing';

const addShopIdAsKey = store => (Component, props) => {
  // Adding a shopId as a 'key' prop forces route reload on shopId change
  const state = store.getState();
  const user = getActiveBrandId(state) || getShop(state);
  const passProps = { ...props, key: user };
  return <Component {...passProps} />;
};

const removeModalClassFromHtml = () => {
  // Remove custom css to prevent scrolling on iOs
  $('html').removeClass('has-modal');
};

const onRouteChange = (prevState, nextState, replace, callback) => {
  containerApp.persistQuery(prevState, nextState, replace, callback);
  RouterBridge.setParams({
    query: nextState.location.query,
    params: nextState.params,
  });
};

// since this handler is attached only to the root route, it will be called only once
const onRouteEnter = (nextState, replace, callback) => {
  RouterBridge.setParams({
    query: nextState.location.query,
    params: nextState.params,
  });
  callback();
};

export default (store, history) => (
  <Router
    history={history}
    render={applyRouterMiddleware(useScroll())}
    createElement={addShopIdAsKey(store)}
    onUpdate={removeModalClassFromHtml}
  >
    <Route component={containerApp.BottomPadding} onChange={onRouteChange} onEnter={onRouteEnter}>
      {publicRoutes(store)}
      {shopRoutes(store)}
      {adminRoutes(store)}
      {barberRoutes(store)}
      {customerRoutes(store)}
      {brandRoutes(store)}
      {authRedirectRoutes(store)}
    </Route>
  </Router>
);
